import _default from './TextArea';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/TextArea/index.js
// module id = 380
// module chunks = 0